<template>
  <div>
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>

      <van-tabbar
        v-model="active"
        v-if="$route.path == '/customer'
      || $route.path == '/task'
      || $route.path == '/remind'
      || $route.path == '/employee' "
      >
        <van-tabbar-item icon="contact">客户</van-tabbar-item>

        <van-tabbar-item
          v-if="$store.state.employee.state.remind"
          icon="records"
          :info="$store.state.employee.state.remind.toString()"
        >
          提醒
        </van-tabbar-item>
        <van-tabbar-item
          v-else
          icon="records"
        >
          提醒
        </van-tabbar-item>

        <van-tabbar-item icon="completed">
          任务
        </van-tabbar-item>

        <van-tabbar-item icon="home">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
  export default {
    name: "layout",
    data(){
      return {
        active: 3
      }
    },
    watch: {
      active:function (val, oldVal) {
        // 这里就可以通过 val 的值变更来确定
        switch (val)
        {
          case 0:
            this.$router.push('customer');
            break
          case 1:
            this.$router.push('remind');
            break
          case 2:
            this.$router.push('task');
            break
          case 3:
            this.$router.push('employee');
            break

        }
      },
      '$route'(to, from) {
        if (this.$route.name === 'customer') {
          this.active = 0
        }
        if (this.$route.name === 'remind') {
          this.active = 1
        }
        if (this.$route.name === 'task') {
          this.active = 2
        }
        if (this.$route.name === 'employee') {
          this.active = 3
        }

        if(this.$route.name !== 'customer-search' && this.$route.name !== 'customer-create' && this.$route.name !== 'customer-edit'){
          //获取提醒个数
          this.$api.post('/api/employee/remind/count', null,
            r => {
              this.$store.state.employee.state.remind = r.count
            }
          )
        }

        //获取下拉条件
        if(!this.$store.state.customer.state.options.status){
          this.$api.post('/api/base/options',null,
            r => {
              this.$store.state.customer.state.options = r.data
            }
          )
        }

      }
    },
    created: function () {
      if(this.$route.name !== 'login'){
        //获取下拉条件
        if(!this.$store.state.customer.state.options.status){
          this.$api.post('/api/base/options',null,
            r => {
              this.$store.state.customer.state.options = r.data
            }
          )
        }

        if(this.$route.name !== 'customer-search' && this.$route.name !== 'customer-create' && this.$route.name !== 'customer-edit'){
          //获取提醒个数
          this.$api.post('/api/employee/remind/count', null,
            r => {
              this.$store.state.employee.state.remind = r.count
            }
          )
        }


        if (this.$route.name === 'customer') {
          this.active = 0
        }
        if (this.$route.name === 'remind') {
          this.active = 1
        }
        if (this.$route.name === 'task') {
          this.active = 2
        }
        if (this.$route.name === 'employee') {
          this.active = 3
        }
      }
    }
  }
</script>

<style>
.van-panel__header {
  padding: 10px 15px;
}
.van-panel__desc {
  font-size: 12px;
  color: #666;
}
.van-panel__title {
  font-size: 20px;
  color: #333;
  min-height: 35px;
}
.van-popup--bottom {
  width: 100%;
  height: 200px;
  padding: 0;
  border-radius: 0;
}
.van-panel__log {
  font-size: 14px;
  position: absolute;
  top: 10px;
  right: 15px;
  color: #26a2ff;
}
.van-col {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: 21px;
}
.van-doc-demo-block__title {
  margin: 0;
  font-weight: 800;
  font-size: 15px;
  color: rgba(69, 90, 100, 0.6);
  padding: 10px 10px 5px;
}
.checkbox-tag {
  text-align: center;
  margin-bottom: 5px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.van-search__input-wrap {
  position: relative;
  -ms-flex: 1;
  flex: 1;
  height: 34px;
  box-sizing: border-box;
  padding: 8px 24px 8px 35px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout.vue